module.exports = "/img/user-guided-tours/customers-list/columns@2x.png?2ad0037dfa02c5ea936b7254bb7031c2";